import Axios from "axios";
import {
  SET_PRODUCTION_SIZE_LIST,
  UNSET_PRODUCTION_SIZE_LIST,
} from "@/store/mutation-types";

import { sizeResource } from "@/store/api";

// ===================== STATE =====================
const state = {
  getProductionSizeList: [],
};

// ===================== GETTERS =====================
const getters = {
  getProductionSizeList(state) {
    return state.getProductionSizeList;
  },
};

// ===================== MUTATIONS =====================
const mutations = {
  [SET_PRODUCTION_SIZE_LIST](state, data) {
    state.getProductionSizeList = data;
  },

  [UNSET_PRODUCTION_SIZE_LIST](state) {
    state.getProductionSizeList = [];
  },
};

// ===================== ACTIONS =====================
const actions = {
  // ----------- GET LIST -----------
  getProductionSizeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(sizeResource, { data })
        .then(response => {
          commit(SET_PRODUCTION_SIZE_LIST, response.data.data);
          resolve(response);
        })
        .catch(error => {
          commit(UNSET_PRODUCTION_SIZE_LIST);
          reject(error);
        });
    });
  },

  // ----------- CREATE -----------
  saveProductionSize({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(sizeResource, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // ----------- UPDATE -----------
  updateProductionSize({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      const url = `${sizeResource}/${id}`;

      Axios.put(url, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

// ===================== EXPORT =====================
export default {
  state,
  getters,
  actions,
  mutations,
};
